import React from 'react';
import { ArrowRight } from 'lucide-react';

export default function Hero() {
  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .hero-section {
            padding-top: 40px !important;
          }
          .hero-content {
            padding: 60px 24px 40px !important;
          }
          .hero-button {
            width: 100%;
            justify-content: center !important;
          }
        }
      `}</style>
      
      <section className="hero-section" style={{ paddingTop: '64px' }}>
        {/* Text content */}
        <div className="hero-content" style={{ textAlign: 'center', padding: '80px 24px 60px', maxWidth: '900px', margin: '0 auto' }}>
        <h1
          className="fade-in-up"
          style={{
            fontSize: 'clamp(36px, 5vw, 64px)',
            fontWeight: '800',
            color: '#111827',
            lineHeight: 1.15,
            marginBottom: '24px',
            letterSpacing: '-1px',
          }}
        >
          The best custom{' '}
          <span style={{ color: '#0099CC' }}>software development</span>{' '}
          for your business
        </h1>
        <p
          className="fade-in-up-delay"
          style={{
            fontSize: '18px',
            color: '#6B7280',
            lineHeight: 1.7,
            maxWidth: '640px',
            margin: '0 auto 36px',
          }}
        >
          DISION Tech is providing innovative and effective software development products and cyber security solutions as a trusted partner for businesses of all sizes and industries.
        </p>
        <div className="fade-in-up-delay">
          <a
            href="#"
            className="hero-button"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: '#F97316',
              color: 'white',
              padding: '14px 32px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '16px',
              fontWeight: '600',
              transition: 'background-color 0.2s ease, transform 0.2s ease',
              minHeight: '48px'
            }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#EA580C'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#F97316'; e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            Discover now <ArrowRight size={18} />
          </a>
        </div>
      </div>

      {/* Hero Banner Image */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px 0' }}>
        <div style={{ borderRadius: '16px', overflow: 'hidden', lineHeight: 0 }}>
          <img
            src="/pictures/Image_8_021c93e756.webp"
            alt="DISION Tech team working"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
              objectFit: 'cover',
            }}
            onError={e => {
              e.target.src = 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&q=80';
            }}
          />
        </div>
      </div>
      </section>
    </>
  );
}
